<template>
    <div>
        <ValidationObserver ref="applicationStatusFormValidate">
            <b-row>
                <b-col cols="12" md="8" lg="8">
                    <b-row>
                        <b-col cols="12" md="6">
                            <ValidationProvider name="group" rules="required" v-slot="{ errors }">
                                <b-form-group :label="$t('application_group')">
                                    <multi-selectbox v-model="formData.group"
                                                     :options="groupOptions"
                                                     :multiple="false"
                                                     :validateError="errors[0]"/>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="6">
                            <b-form-group :label="$t('status')">
                                <ValidationProvider name="status" rules="required" v-slot="{ errors }">
                                    <multi-selectbox v-model="formData.status"
                                                     :options="statusOptions"
                                                     :multiple="false"
                                                     :validateError="errors[0]"/>
                                </ValidationProvider>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="12">
                            <ValidationProvider name="meeting_note" rules="required" v-slot="{ errors }">
                                <b-form-group :label="$t('meeting_note')">
                                    <b-form-textarea v-model="formData.meeting_note" rows="3"
                                                     :state="errors[0] ? false : null" />
                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]" />
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <div class="d-flex justify-content-center mb-3 mt-4">
                <processing-button :processing="loading" variant="primary" v-if="updateMode"
                                   :label="$t('save')" @click="updateStatus" />
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import MultiSelectbox from "@/components/interactive-fields/MultiSelectbox"
import ProcessingButton from '@/components/elements/ProcessingButton'

export default {
    name: 'ApplicationStatusTab',
    components: {
        ValidationObserver,
        ValidationProvider,
        MultiSelectbox,
        ProcessingButton
    },
    props: {
        formData: {
            type: Object,
            required: true
        },
        updateMode: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false,
            groupOptions: [
                { value: 'pending', text: this.$t('pending') },
                { value: 'bisep', text: this.$t('bisep') }
            ],
            statusOptions: [
                { value: 'pending', text: this.$t('pending') },
                { value: 'accepted', text: this.$t('accepted') },
                { value: 'confirmed', text: this.$t('confirmed') },
                { value: 'archive', text: this.$t('archive') },
                { value: 'placed_to', text: this.$t('placed_to') }
            ]
        }
    },
    methods: {
        async updateStatus() {
            const isValid = await this.$refs.applicationStatusFormValidate.validate();
            if (isValid) {
                this.loading = true
                this.$toast.success(this.$t('success'))
                this.loading = false
                this.$emit('next', 2)
            }
        }
    }
}
</script>
